import {
    Container,
    SkeletonMenu,
    SkeletonTabs,
    SkeletonSearch,
    SkeletonTableContainer,
    SkeletonCard,
    SkeletonIcon,
    SkeletonPlano,
    SkeletonBar,
    SkeletonActions,
    SkeletonBadge,
    SkeletonButton,
} from "./styles";

export default function PlanosSkeleton() {
    return (
        <Container>
            <SkeletonMenu>
                <SkeletonTabs />
                <SkeletonSearch />
            </SkeletonMenu>
            <SkeletonTableContainer>
                {[1, 2, 3, 4, 5].map((i) => (
                    <SkeletonCard key={i}>
                        <SkeletonIcon />
                        <SkeletonPlano>
                            <div className="line-title" />
                            <div className="line-subtitle" />
                        </SkeletonPlano>
                        <SkeletonBar width="70%" />
                        <SkeletonBar width="60%" />
                        <SkeletonBar width="30%" />
                        <SkeletonActions>
                            <SkeletonBadge />
                            <SkeletonButton />
                            <SkeletonButton />
                        </SkeletonActions>
                    </SkeletonCard>
                ))}
            </SkeletonTableContainer>
        </Container>
    );
}
